import * as React from "react";
import { Dialog, Skeleton } from "@/components/ui";

/** The composer's shape while it loads (preview card, looks, style bar, caption, footer), so nothing jumps. */
export const ComposerSkeleton: React.FC<{ showLooks: boolean }> = ({ showLooks }) => (
  <>
    <Dialog.Content className="min-h-0 overflow-y-auto" aria-busy="true">
      <div className="grid w-full grid-cols-1 gap-6 md:grid-cols-12" data-testid="composer-loading">
        <div className="md:col-span-5">
          <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
            <div className="flex items-center gap-2.5 px-3 py-2.5">
              <Skeleton className="size-8 rounded-full" />
              <div className="flex flex-col gap-1.5">
                <Skeleton className="h-3 w-24" />
                <Skeleton className="h-2.5 w-12" />
              </div>
            </div>
            <Skeleton className="aspect-[4/5] w-full rounded-none" />
            <div className="flex items-center gap-4 px-3 py-2.5">
              <Skeleton className="size-5 rounded-md" />
              <Skeleton className="size-5 rounded-md" />
              <Skeleton className="size-5 rounded-md" />
              <Skeleton className="ml-auto size-5 rounded-md" />
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-4 md:col-span-7">
          {showLooks && (
            <div className="flex flex-col gap-2">
              <Skeleton className="h-3 w-20" />
              <div className="grid grid-cols-[repeat(auto-fill,minmax(96px,1fr))] gap-3">
                {Array.from({ length: 5 }, (_, i) => (
                  <Skeleton key={i} className="aspect-square w-full rounded-xl" />
                ))}
              </div>
            </div>
          )}
          <div className="flex divide-x divide-slate-200 overflow-hidden rounded-xl border border-slate-200">
            {Array.from({ length: showLooks ? 2 : 3 }, (_, i) => (
              <div key={i} className="flex flex-1 items-center gap-2.5 px-3 py-2">
                <Skeleton className="size-8 rounded-md" />
                <div className="flex flex-col gap-1.5">
                  <Skeleton className="h-2.5 w-14" />
                  <Skeleton className="h-3.5 w-20" />
                </div>
              </div>
            ))}
          </div>
          <div className="flex flex-col gap-2">
            <Skeleton className="h-3 w-16" />
            <Skeleton className="h-24 w-full rounded-md" />
          </div>
        </div>
      </div>
    </Dialog.Content>
    <Dialog.Footer className="flex-col sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-2">
        <Skeleton className="h-3 w-12" />
        <Skeleton className="size-7 rounded-full" />
        <Skeleton className="size-7 rounded-full" />
        <Skeleton className="ml-2 h-4 w-12" />
      </div>
      <Skeleton className="h-9 w-full rounded-lg sm:w-36" />
    </Dialog.Footer>
  </>
);
